import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const NAVIGATION_EXPANDED_WIDTH = 346;
const NAVIGATION_COLLAPSED_WIDTH = 20;

export const PageWrapper = styled.div<{ isNavigationExpanded: boolean }>`
  bottom: 0;
  display: grid;
  grid-template-areas:
    'navigation header'
    'navigation body'
    'navigation footer';
  grid-template-columns: ${({ isNavigationExpanded }) =>
      isNavigationExpanded ? NAVIGATION_EXPANDED_WIDTH : NAVIGATION_COLLAPSED_WIDTH}px 1fr;
  grid-template-rows: min-content 1fr;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`;

export const PageHeader = styled.div`
  background: ${colors.pearl};
  border-bottom: 1px solid ${colors.silt};
  grid-area: header;
  overflow: auto;
  position: relative;
  z-index: 2;
`;

export const PageNavigation = styled.div`
  background: ${colors.white};
  grid-area: navigation;
  overflow: visible;
  position: relative;
  z-index: 3;
  border-right: 1px solid #e0deda;
`;

export const PageBody = styled.div`
  background: ${colors.white};
  grid-area: body;
  overflow-x: auto;
  position: relative;
`;

export const TogglePageSidebarButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: -12px;
`;

export const PageFooter = styled.div`
  grid-area: footer;
  background: ${colors.pearl};
  border-top: 1px solid ${colors.silt};
  position: sticky;
  z-index: 2;
  bottom: 0;
`;

export const VisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
